import React from "react";
import {
  Checkbox,
  Chip,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "convertupleads-theme";
import NameAvatar from "../DataTable/NameAvatar";
import { ChevronUpDownIcon } from "../../../../common/Icons/Icons";

const BorderedTable = () => {
  // const StyledTableCell = styled(TableCell)(({ theme }) => ({
  //   [`&.${tableCellClasses.head}`]: {
  //     "&:first-of-type": {
  //       paddingLeft: 50,
  //     },
  //   },
  //   padding: theme.spacing(0.5, 1.5),
  //   border: `1px solid ${theme.palette.other.outlinedBorder}`,
  // }));

  return (
    <>
      <TableContainer>
        <Table variant={"bordered"}>
          <TableHead>
            <TableRow>
              <TableCell>
                <Stack direction="row" alignItems="center">
                  <Checkbox size={"small"} />
                  User
                </Stack>
              </TableCell>
              <TableCell>Email</TableCell>
              <TableCell>
                <Stack
                  direction={"row"}
                  justifyContent={"space-between"}
                  alignItems="center"
                >
                  <span>Phone</span>
                  <IconButton size={"small"}>
                    <ChevronUpDownIcon fontSize={"small"} />
                  </IconButton>
                </Stack>
              </TableCell>
              <TableCell>Account status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                <NameAvatar>
                  <Checkbox size={"small"} />
                </NameAvatar>
              </TableCell>
              <TableCell>jss@gmail.com </TableCell>
              <TableCell>1234908 </TableCell>
              <TableCell>
                <Chip
                  label="Active"
                  color="success"
                  size="xSmall"
                  variant="outlined"
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <NameAvatar>
                  <Checkbox size={"small"} />
                </NameAvatar>
              </TableCell>
              <TableCell>jss@gmail.com </TableCell>
              <TableCell>1234908 </TableCell>
              <TableCell>
                <Chip
                  label="Active"
                  color="success"
                  size="xSmall"
                  variant="outlined"
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <NameAvatar>
                  <Checkbox size={"small"} />
                </NameAvatar>
              </TableCell>
              <TableCell>jss@gmail.com </TableCell>
              <TableCell>1234908 </TableCell>
              <TableCell>
                <Chip
                  label="Active"
                  color="success"
                  size="xSmall"
                  variant="outlined"
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <NameAvatar>
                  <Checkbox size={"small"} />
                </NameAvatar>
              </TableCell>
              <TableCell>jss@gmail.com </TableCell>
              <TableCell>1234908</TableCell>
              <TableCell>
                <Chip
                  label="Active"
                  color="success"
                  size="xSmall"
                  variant="outlined"
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <NameAvatar>
                  <Checkbox size={"small"} />
                </NameAvatar>
              </TableCell>
              <TableCell>jss@gmail.com </TableCell>
              <TableCell>1234908</TableCell>
              <TableCell>
                <Chip
                  label="Active"
                  color="success"
                  size="xSmall"
                  variant="outlined"
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <NameAvatar>
                  <Checkbox size={"small"} />
                </NameAvatar>
              </TableCell>
              <TableCell>jss@gmail.com </TableCell>
              <TableCell>1234908 </TableCell>
              <TableCell>
                <Chip
                  label="Active"
                  color="success"
                  size="xSmall"
                  variant="outlined"
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default BorderedTable;
